import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

axios.defaults.withCredentials = true;

export const progressService = {
  getSummary: () => axios.get(`${API_URL}/api/progress/summary`),
  getDays: () => axios.get(`${API_URL}/api/progress/days`),
  updateSession: (sessionId, data) => axios.post(`${API_URL}/api/progress/session/${sessionId}`, data),
  updateLesson: (lessonId, data) => axios.post(`${API_URL}/api/progress/lesson/${lessonId}`, data),
};
